import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiTab from '@material-ui/core/Tab';
import Moment from 'moment';
import PlanningDataTab from './PlanningDataTab';

const styles = theme => ({
  wrapper: {
    alignItems: 'flex-start',
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 'bold',
  },
  selected: {
    backgroundColor: theme.palette.facet.accentBlue11,
    color: theme.palette.common.white,
  },
});

const Tab = ({
  classes,
  label,
  lastUpdateTime,
  isMissingData,
  SubtitleComponent,
  ...rest
}) => {
  const formattedLastUpdateTime = new Moment(lastUpdateTime).format('MM-DD-YY');

  return (
    <MuiTab
      disableRipple
      classes={{
        wrapper: classes.wrapper,
        selected: classes.selected,
      }}
      component={PlanningDataTab}
      label={label}
      lastUpdateTime={formattedLastUpdateTime}
      isMissingData={isMissingData}
      SubtitleComponent={SubtitleComponent}
      {...rest}
    />
  );
};

Tab.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  lastUpdateTime: PropTypes.string.isRequired,
  isMissingData: PropTypes.bool,
  SubtitleComponent: PropTypes.object,
};

Tab.defaultProps = {
  isMissingData: false,
  SubtitleComponent: null,
};

export default withStyles(styles)(Tab);
